import { TLinkComponentProps } from "@preem/core/ssr";
import { Link } from "gatsby";

const GatsbyLink = ({ url, ariaLabel, children, className, onClick, rel }: TLinkComponentProps) => {
  return (
    <Link to={url} aria-label={ariaLabel} className={className} onClick={onClick} rel={rel}>
      {children}
    </Link>
  );
};

export { GatsbyLink };
